import { IDateValue } from './types';

/**
 * A internal measurment wrapper that wraps
 * the measurement object from the server
 * and implements IDateValue so it can be used
 * in aggregration and charting
 */

interface MeasurementSubject {
  id: string;
  slug: string;
  name: string;
}

interface MeasurementTracker {
  id: string;
  name: string;
  slug: string;
  type: TrackerType;
}

export class Measurement implements IDateValue {
  public get dateString() {
    return this.notedAt;
  }

  public get date() {
    return new Date(this.notedAt);
  }
  public value: number;
  public subject: MeasurementSubject;
  public tracker: MeasurementTracker;
  public readonly notedAt: string;

  public constructor(input: {
    notedAt: string;
    value: number;
    subject: MeasurementSubject;
    tracker: MeasurementTracker;
  }) {
    const { notedAt, value, subject, tracker } = input;

    this.notedAt = notedAt;
    this.value = value;
    this.subject = subject;
    this.tracker = tracker;
  }
}
